<template>
  <svg
    height="100%"
    :width="width"
    viewBox="0 0 10 100"
    preserveAspectRatio="none"
    xmlns="http://www.w3.org/2000/svg"
    class="commitment-session-hairline">
    <g>
      <path
        :d="'M5,0 v100'"
        :stroke="colorBg"
        :stroke-width="width"
        stroke-linecap="butt" />

      <path
        v-for="(segment,idx) in sessions"
        :key="'seg-'+idx"
        :d="path_for_segment(segment)"
        :stroke="active_segment === idx ? 'red' : colorActive"
        :stroke-width="width"
        stroke-linecap="butt"
        @mouseover="onMouseOver(idx)"
        @mouseout="active_segment = null" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    sessions: {},
    colorBg: { default: 'black' },
    colorActive: { default: '#67c23a' },
    width: { default: 10 }
  },
  data() {
    return {
      active_segment: null
    }
  },
  methods: {
    path_for_segment(segment) {
      let y1 = segment[0]
      let y2 = segment[1]
      return `M5,${y1} L5,${y2} `
    },
    onMouseOver(idx) {
      console.log("tooltip", idx)
      this.active_segment = idx;
    }
  }
};
</script>

<style>
svg.commitment-session-hairline {
  border-radius: 5px
}
</style>
